module.exports = __webpack_public_path__ + "img/car-shadow-3.b815fd75.png";